import { render, staticRenderFns } from "./SettlementView.vue?vue&type=template&id=73aa50b8&"
import script from "./SettlementView.vue?vue&type=script&lang=js&"
export * from "./SettlementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports